import {LinkIcon, UploadIcon, FilePlusIcon} from "lucide-react";

import {KnowledgeBaseDocumentTypeModel} from "@/api/models/knowledge-bases/documents";

export const VECTOR_DATABASE_THRESHOLD = 0;
export const VECTOR_DATABASE_MAX_RESULTS = 16;

export const KNOWLEDGE_BASE_DOCUMENT_ICONS = {
  [KnowledgeBaseDocumentTypeModel.TEXT]: <FilePlusIcon />,
  [KnowledgeBaseDocumentTypeModel.FILE]: <UploadIcon />,
  [KnowledgeBaseDocumentTypeModel.LINK]: <LinkIcon />,
} as const;

export const KNOWLEDGE_BASE_DOCUMENT_TYPES = {
  [KnowledgeBaseDocumentTypeModel.TEXT]: "Blank Document",
  [KnowledgeBaseDocumentTypeModel.FILE]: "PDF File",
  [KnowledgeBaseDocumentTypeModel.LINK]: "URL Link",
} as const;

export const KNOWLEDGE_BASE_DOCUMENT_CREATE_TITLES = {
  [KnowledgeBaseDocumentTypeModel.FILE]: "Upload PDF File",
  [KnowledgeBaseDocumentTypeModel.TEXT]: "Create Blank Document",
  [KnowledgeBaseDocumentTypeModel.LINK]: "Attach from URL",
} as const;

export const KNOWLEDGE_BASE_DOCUMENT_CREATE_DROPDOWN_ITEMS = [
  {
    key: KnowledgeBaseDocumentTypeModel.TEXT,
    title:
      KNOWLEDGE_BASE_DOCUMENT_CREATE_TITLES[
        KnowledgeBaseDocumentTypeModel.TEXT
      ],
    description: "Manually add the information to a blank document.",
    icon: KNOWLEDGE_BASE_DOCUMENT_ICONS[KnowledgeBaseDocumentTypeModel.TEXT],
  },
  {
    key: KnowledgeBaseDocumentTypeModel.FILE,
    title:
      KNOWLEDGE_BASE_DOCUMENT_CREATE_TITLES[
        KnowledgeBaseDocumentTypeModel.FILE
      ],
    description: "Directly upload your file with the required information.",
    icon: KNOWLEDGE_BASE_DOCUMENT_ICONS[KnowledgeBaseDocumentTypeModel.FILE],
  },
  {
    key: KnowledgeBaseDocumentTypeModel.LINK,
    title:
      KNOWLEDGE_BASE_DOCUMENT_CREATE_TITLES[
        KnowledgeBaseDocumentTypeModel.LINK
      ],
    description: "Scan information from URL link to document or website.",
    icon: KNOWLEDGE_BASE_DOCUMENT_ICONS[KnowledgeBaseDocumentTypeModel.LINK],
  },
] as const;
